#import "../fragments/prospector-contacts-fragment.graphql"

query GetProspectorContacts($input: ProspectorFilters!, $skip: Int!) {
    prospectorContacts(filters: $input, skip: $skip) {
        totalCount
        mcfxContacts {
            ...ProspectorContactsFragment
        }
        nextSkip
    }
}
